import { useState } from "react";
import { Link } from "react-router-dom";
import { Player } from "@lottiefiles/react-lottie-player";
import api from "../services/api";
import toast from "react-hot-toast";
import logoImg from "../assets/logo.png";
import "./Auth.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sentMessage, setSentMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSentMessage("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSentMessage(data.message || "");
      toast.success("If this email is registered, check your inbox and spam.");
    } catch (err) {
      toast.error(err.response?.data?.message || "Request failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page auth-page-split">
      <div className="auth-split-left">
        <div className="auth-lottie-wrap">
          <Player
            src="https://assets10.lottiefiles.com/packages/lf20_qp1q7mct.json"
            className="auth-lottie"
            autoplay
            loop
          />
        </div>
        <div className="auth-left-content">
          <h1 className="auth-left-title">IEO/SCS/ICD Task Management</h1>
          <p className="auth-left-tagline">Reset your password securely.</p>
        </div>
      </div>
      <div className="auth-split-right">
        <div className="auth-card auth-card-split">
          <div className="auth-logo-wrap">
            <img src={logoImg} alt="Logo" className="auth-logo" />
          </div>
          <h2 className="auth-title">Forgot password</h2>

          {sentMessage ? (
            <p
              className="auth-subtitle"
              style={{ color: "#059669", marginBottom: 16 }}
            >
              {sentMessage}
            </p>
          ) : null}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input
                className="form-control"
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
              />
            </div>
            <button
              className="btn btn-primary auth-btn"
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <span
                  className="spinner"
                  style={{ width: 18, height: 18, borderWidth: 2 }}
                />
              ) : (
                "Send reset link"
              )}
            </button>
          </form>
          <p className="auth-link">
            <Link to="/login">Back to sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
